<template>
  <div class="p_detail">
   <img :src="domain+data.pictureurls" v-if='data.pictureurls' class="p_detail_banner">
   <img :src="domain+data.litpic" v-if='!data.pictureurls' class="p_detail_banner">
   <p class="p_detail_name">{{data.title}}</p>
   <div class="p_detail_tabs clearfix">
     <div :class="{p_detail_tab:true,active:cpxq}" @click='cpxq=true;cpcs=false'>
       产品详情
     </div>
     <div :class="{p_detail_tab:true,active:cpcs}"  @click='cpxq=false;cpcs=true'>
       产品参数
     </div>
   </div>
   <div class="cpxq_wrap m animated slideInRight" v-show='!cpcs' v-html='data.content'>
   
   </div>
   <div class="cpcs_wrap animated slideInRight" v-show='cpcs'>
      <div class="cpcs_list clearfix">
        <div class="cpcs_item">所属品类：{{cate.name}}</div>
        <div class="cpcs_item">品牌：{{data.brand}}</div>
      </div>
      <div class="cpcs_list clearfix">
        <div class="cpcs_item">系列：{{data.series}}</div>
        <div class="cpcs_item">型号：{{data.model}}</div>
      </div>
      <div class="cpcs_list clearfix">
        <div class="cpcs_item">规格：{{data.specification}}</div>
        <div class="cpcs_item">颜色：{{data.color}}</div>
      </div>
      <div class="cpcs_list clearfix">
        <div class="cpcs_item">材质：{{data.material}}</div>
        <div class="cpcs_item">使用人数：{{data.nums}}</div>
      </div>
      <div class="cpcs_list clearfix">
        <div class="cpcs_item">设计师：{{data.designer}}</div>
        <div class="cpcs_item">产地：{{data.area}}</div>
      </div>
      <div class="cpcs_list clearfix">
        <div class="cpcs_item">货期：{{data.updatetime}}</div>
      </div>
      <div class="cpcs_list clearfix">
        <div class="cpcs_item">安装方式：{{data.installation}}</div>
      </div>
   </div>
  </div>
</template>

<script>
/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
import animatecss from 'animate.css'
export default {
  name: 'app',
  data(){
    return{
      cpxq:true,
      cpcs:false,
      data:'',
      cate:''
    }
  },
  watch:{
    '$route':function(to,from){
      this.getDetail()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getDetail()
  },
  methods:{
    getDetail:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_product_detail', this.$qs.stringify({
        id:this.$route.params.ids
      }))
      .then(response => {
        console.log(response);
        this.data=response.data.data
        this.cate=response.data.cate
        

      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
 .p_detail{

 }
 .p_detail_banner{
  display: block;
  width: 100%;
 }
 .p_detail_name{
  font-size: 0.3rem;
  color: #020202;
  font-weight: bold;
  padding: 0.5rem 0.18rem;
 }
 .p_detail_tabs{

  border-bottom: 1px solid #d4d4d4;
  box-sizing: border-box;
 }
 .p_detail_tab{
  font-size: 0.3rem;
  color: #000;
  text-align: center;
  width: 50%;
  float: left;
  padding-bottom: 0.3rem;
 }
 .p_detail_tab.active{
  border-bottom: 2px solid #3478f7;
  color: #3478f7;
  box-sizing: border-box;
 }
 .cpcs_wrap{
  padding: 0 0.18rem;
 }
 .cpcs_list{
  border-bottom: 1px dashed #d5d5d5;
  padding: 0.3rem 0;
 }
 .cpcs_item{
  font-size: 0.24rem;
  color: #020202;
  width: 50%;
  float: left;
  padding-right: 0.2rem;
  box-sizing: border-box;
 }
 .cpxq_wrap{
  padding: 0.2rem 0;
 }
 .cpxq_wrap img{
  width: 100%;
  display: block;
 }
</style>


// WEBPACK FOOTER //
// src/components/mobile/product_detail.vue